import { loadingAsyncState, HttpResult, AsyncState, unloadedAsyncState, loadedAsyncState } from "widgets-for-react";
import { FormState, FormData } from "./types";
import { List, Map } from 'immutable'
import * as i18next from 'i18next'
import { Field } from "../../generated_models";
import { mapLanguage } from "../../helpers";
import { get_lang_from_url } from "../map/maps_utils";

export let postFormSubmissionState = (form_id:number, form_state:FormState) : AsyncState<string> => {
  if(form_state.form_data.kind != "loaded") return unloadedAsyncState()
  //if(!form_state.form_data.value.form.store_submissions_locally) return unloadedAsyncState()
  let steps = form_state.form_data.value.steps
  let userEmail = ""
  let ConfirmationEmail = "true"
  let files:List<File> = List<File>()
  form_state.form_data.value.steps.forEach(s => s.fields.forEach(f => {
    if(f.Kind == "UserEmail")
      userEmail = f.user_input
    if ((f.Kind == "Checkbox") && (((f.title.toUpperCase().indexOf("CONF")>-1)||(f.title.toUpperCase().indexOf("BEVESTIGING")>-1)) && (f.title.toUpperCase().indexOf("MAIL")>-1) ))
      ConfirmationEmail= f.user_input
    if(f.Kind == "Attachement" && f.file != undefined)
      files = files.push(f.file)
  }))
  let raw_content = JSON.stringify(
    steps.map(s => (
      {
        fields:s.fields
                  .filter(x => x.Kind != "ReadonlyText")
                  .map(x =>
                    x.Kind == "Attachement" && x.file ?
                      ({...x, user_input:x.file.name })
                    : x.Kind == "Checkbox" ?
                      x.user_input == "true" ?
                        ({...x, user_input: i18next.t("form:form_checked") })
                      : ({...x, user_input: i18next.t("form:form_not_checked")})
                    : x)})))
  let content = {
    RawContent : raw_content,
    UserEmail : userEmail,
    ConfirmationEmail : ConfirmationEmail,
    Context : form_state.custom_context
  }

  let formData = new window.FormData()
  formData.append("content", JSON.stringify(content))
  steps.forEach(x => x.fields.forEach(y => y.Kind == "Attachement" && y.file && formData.append(y.file.name, y.file)))
    
  return loadingAsyncState(async () => {
    const lang = mapLanguage(get_lang_from_url(_ => "")).replace(/\//g, '')
        let fetch_res = await fetch(
          `/api/v1/CustomFormLogic/${lang}/SubmitFormData/${form_id}`, 
          { method: 'put', 
            body: formData,
            credentials: 'include'
          }
        )
        if(!fetch_res.ok) {
          return {kind:"failed", status:400 }
        }
        let res : HttpResult<string> = {kind:"result", status:200, value:"ok"}
        return res
    })
}

export let getFormState = (events: string[], form_title: string): FormState =>
  getFormStateBase(events, () =>
    fetch(`/api/v1/CustomFormLogic/GetFormData/${form_title}`, {
      method: 'get',
      credentials: 'include',
      headers: { 'content-type': 'application/json' }
    })
  )

export let getGravityFormState = (events: string[], form_id: string, lang = "en"): FormState =>
  getFormStateBase(
    events,
    () =>
      fetch(`/api/v1/CustomFormLogic/GetGravityFormData/${form_id}?lang=${lang.replace(/\//g, '')}`, {
        method: 'get',
        credentials: 'include',
        headers: { 'content-type': 'application/json' }
      }),
    loadedAsyncState(`/api/v1/CustomFormLogic/SubmitGravityForm/${form_id}`)
  )

export let getFormStateBase = (events: string[], p: () => Promise<Response>, submissionLogic: AsyncState<string> = unloadedAsyncState()): FormState => {
  let res: FormState = {
    form_submission_logic: submissionLogic,
    form_started: false,
    dependencies_state: Map(),
    context: {
      external_options: Map<string, string[]>().set("locationArray", events)
    },
    form_data: loadingAsyncState(async () => {
      let fetch_res = await p()
      if (!fetch_res.ok) return { kind: "failed", status: 400 }
      let data = await fetch_res.json()
      data.steps = data.steps.map(step =>
        ({
          ...step,
          fields: step.fields.map(f => {
            let field:Field = f.field
            field.Kind = f.field_kind
            let maybe_answers = f.maybe_answers
            let result: any = null
            if (field.Kind == "SimpleDate") {
              result = { ...field, user_input: undefined, maybe_answers }
            }
            else if (field.Kind == "CheckboxMultiSelect") {

              let user_input = maybe_answers.map((a): string => {
                if (a.isDefaultSelected) {
                  return "[" + a.value + "]"
                }
                return ""
              })
              if (user_input.length == 0) {
                result = { ...field, user_input: "", maybe_answers }
              }
              else {
                result = { ...field, user_input: user_input.reduce((a, b) => a + b), maybe_answers }
              }
            }
            else {
              result = { ...field, user_input: field.optionalDefaultValue ? field.optionalDefaultValue : undefined, maybe_answers }
            }
            return result
          }),
          dependencies: step.dependencies.map(f => {
            return { ...f, is_met: false, dependency: {...f.dependency, Kind:f.dependency_kind }}
          })
        }))

      let res: HttpResult<FormData> = { kind: "result", status: 200, value: data }
      return res
    }),
  }
  return res as any
}

// export async function upload_files(form_id:number,upload_hash:string,files:File[]) : Promise<void> {
//   let files_data = new FormData()
//   files.forEach(file => files_data.append(file.name, file))
//   files_data.append("upload_hash", upload_hash)

//   // let allowed_extensions = ["txt", "rtf", "pdf", "doc", "docx", "odt", "tex", "wpd"]
//   // let extension = file.name.substring(file.name.lastIndexOf('.')+1, file.name.length) || file.name
//   // if (!allowed_extensions.includes(extension)) {
//   //   window.alert("This file type is not allowed")
//   //   return
//   // }

//   let headers = new Headers()
//   headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
//   let res = await fetch(`/api/v1/CustomFormLogic/SubmitFormData/FileUpload/${form_id}`,  {
//     method: "POST",
//     body: files_data, credentials: 'include', headers: headers })
//   if (!res.ok) throw Error(res.statusText)
//   return
// }

// export let GetFormTitles = (events: string[]): FormState => {
//   let res: FormState = {
//     form_submission_logic: unloadedAsyncState(),
//     dependencies_state: Immutable.Map(),
//     context: {
//       external_options: Immutable.Map<string, string[]>().set("locationArray", events)
//     },
//     form_data: loadingAsyncState(async () => {
//       let fetch_res = await fetch(`/api/v1/CustomFormLogic/GetFormTitles`, { method: 'get', credentials: 'include', headers: { 'content-type': 'application/json' } })
//       if (!fetch_res.ok) return { kind: "failed", status: 400 }
//       let data = await fetch_res.json()
//       data.steps = data.steps.map(step =>
//         ({
//           ...step,
//           fields: step.fields.map(f => {
//             let field = f.field
//             let maybe_answers = f.maybe_answers
//             let result = { ...field, user_input: field.optionalDefaultValue ? field.optionalDefaultValue : undefined, maybe_answers }
//             return result
//           }),
//           dependencies: step.dependencies.map(f => {
//             return { ...f, is_met: false }
//           })
//         }))

//       let res: HttpResult<FormData> = { kind: "result", status: 200, value: data }
//       return res
//     }),
//   }
//   return res as any
// }